/**
 * Generates a CSV file with addresses for Google Docs mail merge
 * Compatible with Avery label templates in Google Docs
 * 
 * @param {Array} addresses - Array of address objects with name, address, address2, city, state, zip
 * @returns {Object} Result object with success status and filename
 */
export const generateCSV = (addresses) => {
  // CSV headers - standard format for mail merge
  const headers = ['Name', 'Address Line 1', 'Address Line 2', 'City', 'State', 'ZIP'];
  
  // Convert addresses to CSV rows
  const rows = addresses.map(addr => [
    addr.name || '',
    addr.address || '',
    addr.address2 || '',
    addr.city || '',
    addr.state || '',
    addr.zip || ''
  ]);
  
  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(field => {
      // Escape fields that contain commas, quotes, or newlines
      if (field.includes(',') || field.includes('"') || field.includes('\n')) {
        return `"${field.replace(/"/g, '""')}"`;
      }
      return field;
    }).join(','))
  ].join('\n');
  
  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  const timestamp = new Date().toISOString().split('T')[0];
  const filename = `addresses_${timestamp}.csv`;
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  return {
    success: true,
    filename,
    recordCount: addresses.length
  };
};
